import { Skeleton, TableBody, TableCell, TableRow } from "@mui/material";

const TableRowSkeleton = ({ columnsCount }: { columnsCount: number }) => (
  <TableRow>
    {Array.from({ length: columnsCount }).map((_, index) => (
      <TableCell key={index}>
        <Skeleton variant="text" width="100%" />
      </TableCell>
    ))}
  </TableRow>
);

export const TableSkeleton = ({
  columnsCount,
  rowsCount,
}: {
  columnsCount: number;
  rowsCount: number;
}) => (
  <TableBody>
    {Array.from({ length: rowsCount }).map((_, index) => (
      <TableRowSkeleton key={index} columnsCount={columnsCount} />
    ))}
  </TableBody>
);
